import './style.scss';
import type { ITariffZone } from '../../../../../../../../models/tariff-zone.model';
import { TranslationService } from '../../../../../../../../services/translation.service';

function ZoneIcon({ tariffZones, className }: { tariffZones: ITariffZone[] | undefined; className?: string }) {
  if (!tariffZones || tariffZones.length === 0) return null;

  const sortedZones = tariffZones
    .map((x) => x.shortName)
    .sort()
    .join('');

  // NV-6808: Only show the zone icon if the zone combination is valid
  const validZoneCombinations = ['A', 'B', 'C', 'AB', 'BC', 'ABC'];
  if (!validZoneCombinations.includes(sortedZones)) {
    return null;
  }

  return <span className={`zone-icon bg-blue-800 fg-white rounded text-nowrap ${className ?? ''}`}>{`${TranslationService.get('common.tariffzone')} ${sortedZones}`}</span>;
}

export default ZoneIcon;
